import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import { Seo } from 'src/components';
import Plans from 'src/components/Plans/Plans';
import InfoPagesLayout from 'src/layouts/InfoPagesLayout';
import { PlansPageContainer } from 'src/styles/infoPages';

const PlansPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <InfoPagesLayout title={'plans.title'}>
        <PlansPageContainer>
          <Plans />
        </PlansPageContainer>
      </InfoPagesLayout>
      <Seo title={t('jonniName') + ' - ' + t('plans.title')} />
    </>
  );
};

export default PlansPage;
